import { isAxiosError } from 'axios';

import type { ValidationErrors, ValidateFormInput } from './RegisterUserForm.types';

import { registerUserFormSchema } from '../../schemas/registerUserForm.schemas';

export function validateForm({
  firstName,
  lastName,
  email,
}: ValidateFormInput): ValidationErrors {
  const result = registerUserFormSchema.safeParse({
    firstName,
    lastName,
    email,
  });
  if (result.success) return {};

  const errors: ValidationErrors = {};
  for (const issue of result.error.issues) {
    const field = issue.path[0] as keyof ValidationErrors;
    if (!errors[field]) {
      errors[field] = issue.message;
    }
  }
  return errors;
}

export function isEmailConflictError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 409;
}
